import React, { useEffect, useState } from "react";
import LocalResidentDirector from "./LocalResidentDirector";
import NomineeDirector from "./NomineeDirector";
import { Logo } from "../../../assets/index";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import NomineeShareholder from "./NomineeShareholder";
import NomineeDirectorShareholder from "./NomineeDirectorShareholder";

const DirectorsShareholders = ({
  companyId,
  total_number_of_shares,
  total_issued_share_capital,
  total_paid_up_share_capital,
  use_nominee_director,
  use_nominee_shareholder,
  shareholders,
  resident_directors,
  nominee_director_durations,
  nominee_director_deposits,
  nominee_shareholder_durations,
  nominee_shareholder_deposits,
  nominee_director_shareholder_durations,
  nominee_director_shareholder_deposits,
  currency,
}) => {
  const [activeTab, setActiveTab] = useState(0);

  // Selector
  const { CreateCompany } = useSelector((store) => ({
    CreateCompany: store?.companiesData?.CreateCompanyStatus?.data?.data,
  }));

  // tab selection logic
  useEffect(() => {
    const tabIndex =
      use_nominee_director && use_nominee_shareholder
        ? 3
        : use_nominee_shareholder
        ? 2
        : use_nominee_director
        ? 1
        : 0;

    setActiveTab(tabIndex);
  }, [use_nominee_director, use_nominee_shareholder]);
  const tabs = [
    {
      text: "Use my local resident director ",
      id: 0,
      content: (
        <LocalResidentDirector
          company_id={CreateCompany?.id || companyId}
          resident_directors={resident_directors}
          shareholders={shareholders}
          total_number_of_shares={total_number_of_shares}
          total_issued_share_capital={total_issued_share_capital}
          total_paid_up_share_capital={total_paid_up_share_capital}
          currency={currency}
        />
      ),
      link: "Eligibility Criteria",
      linkUrl:
        "https://www.acra.gov.sg/how-to-guides/setting-up-a-local-company/appointing-directors-company-secretary-and-other-key-personnel",
    },
    {
      text: "Use SGCorpHub's Nominee Director",
      subText:
        "If you are based overseas or need a time buffer to get a local director",
      icon: true,
      id: 1,
      content: (
        <NomineeDirector
          company_id={CreateCompany?.id || companyId}
          resident_directors={resident_directors}
          shareholders={shareholders}
          nominee_director_durations={nominee_director_durations}
          nominee_director_deposits={nominee_director_deposits}
        />
      ),
    },
    {
      text: "Use SGCorpHub's Nominee",
      boldText: "Shareholder",
      subText:
        "If you are based overseas or need a time buffer to get a local shareholder",
      icon: true,
      id: 2,
      content: (
        <NomineeShareholder
          company_id={CreateCompany?.id || companyId}
          resident_directors={resident_directors}
          shareholders={shareholders}
          nominee_shareholder_durations={nominee_shareholder_durations}
          nominee_shareholder_deposits={nominee_shareholder_deposits}
        />
      ),
    },
    {
      text: "Use SGCorpHub's Nominee",
      boldText: "Director & Shareholder",
      subText:
        "If you are based overseas or need a time buffer to get both local director & shareholder",
      icon: true,
      id: 3,
      content: (
        <NomineeDirectorShareholder
          company_id={CreateCompany?.id || companyId}
          resident_directors={resident_directors}
          shareholders={shareholders}
          nominee_director_shareholder_durations={
            nominee_director_shareholder_durations
          }
          nominee_director_shareholder_deposits={
            nominee_director_shareholder_deposits
          }
        />
      ),
    },
  ];

  return (
    <div className="col-span-5 bg-white border rounded py-5 px-6">
      <div className="border-b border-secondary_grey pb-2 mb-5">
        <p className="sm:text-md text-sm mb-1">Thirdly,</p>
        <p className="font-ebGaramond lg:text-2xl sm:text-xl text-base sm:mb-3 mb-1">
          Invite company members
        </p>
      </div>
      {/* tab head */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mb-5">
        {tabs?.map((element) => {
          return (
            <div
              className={`p-4 ${
                activeTab === element?.id ? "bg-light_theme" : "bg-white"
              } cursor-pointer rounded-lg border-2 space-y-3 h-full`}
              onClick={() => {
                setActiveTab(element?.id);
              }}
            >
              <div className="flex flex-col space-y-3 h-full">
                {element?.icon && (
                  <div className="flex justify-start">
                    <img
                      src={Logo}
                      className="w-8 h-8 object-contain"
                      alt="icon"
                    />
                  </div>
                )}
                <div className="space-y-2 flex-1">
                  <p className="text-sm font-medium leading-tight">
                    {element?.text}{" "}
                    {element?.boldText && (
                      <span className="font-bold">{element?.boldText}</span>
                    )}
                  </p>
                  {element?.subText && (
                    <p className="text-xs text-gray-600 leading-relaxed">
                      {element?.subText}
                    </p>
                  )}
                </div>
                {element?.link && (
                  <div className="mt-auto">
                    <Link
                      target="_blank"
                      to={element?.linkUrl}
                      className="text-theme border-b text-sm border-theme hover:opacity-80"
                    >
                      {element?.link}
                    </Link>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      {/* tab content */}
      {tabs?.map((element) => activeTab === element?.id && element?.content)}
    </div>
  );
};

export default DirectorsShareholders;
